import { compareString } from "helpers/generalUtils";
import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.ProductDetail || initialState;

const makeProductDetailSelectField = (field) =>
  createSelector(
    reducerState,
    (productDetailState) => productDetailState[field]
  );

const selectSortedProducts = () =>
  createSelector(
    makeProductDetailSelectField("productDetailData"),
    (products) =>
      products
        .map((opt) => ({
          value: opt.productDetailId,
          label: opt.productName,
        }))
        .sort((item1, item2) => compareString(item1.label, item2.label))
  );
export { reducerState, makeProductDetailSelectField, selectSortedProducts };
